import { ReactElement, Suspense } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import SceneErrorIndicatorFallback from '../SceneErrorIndicatorFallback'
import PlanTemplateImagePlane, {
  PlanTemplateImagePlaneProps,
} from './components/PlanTemplateImagePlane'

export type PlanTemplateImageProps = PlanTemplateImagePlaneProps

/**
 * Plan template (frame, notes, Plankopf) drawn under the floorplan for the plan view's "Vorlage
 * anzeigen". Loads its texture in its own suspense boundary so the rest of the scene keeps
 * rendering while the image arrives.
 */
const PlanTemplateImage = (props: PlanTemplateImageProps): ReactElement => (
  <ErrorBoundary
    fallbackRender={({ error }) => (
      <SceneErrorIndicatorFallback error={error} context="Fehler beim Laden der Planvorlage. " />
    )}
  >
    <Suspense fallback={null}>
      <PlanTemplateImagePlane {...props} />
    </Suspense>
  </ErrorBoundary>
)

export default PlanTemplateImage
